module.exports = __webpack_public_path__ + "static/img/back-top-blue.fa1316c7.png";